module.exports = __webpack_public_path__ + "img/9791130629667.bb34ef62.jpg";